import EditCampaign from "./EditCampaign";
import Archive from "./Archive";
import Clone from "./Clone";
import Download from "./Download";
import PushCampaign from "./PushCampaign";
import LockBudget from "./LockBudget";
import CrossPlatformQA from "./CrossPlatformQA";

import NewBriefCampaignAction from "./NewBriefCampaign";
import UnarchiveAction from "./Unarchive";
import useNewPrimaryCampaignAction from "./NewPrimaryCampaign";
import useNewActivationCampaignAction from "./NewActivationCampaignV2";
import useEditActivationCampaignAction from "./EditActivationCampaign";
import useEditPrimaryCampaignAction from "./EditPrimaryCampaign";
import CampaignDownloadAction from "./CampaignDownload";

const ActionBarHooks = {
	Clone,
	EditCampaign,
	Archive,
	Download,
	PushCampaign,
	LockBudget,
	CrossPlatformQA,
	useNewActivationCampaignAction
};

export {
	ActionBarHooks,
	NewBriefCampaignAction,
	UnarchiveAction,
	useNewPrimaryCampaignAction,
	useNewActivationCampaignAction,
	useEditActivationCampaignAction,
	useEditPrimaryCampaignAction,
	CampaignDownloadAction
};
